import React from 'react'
import stylesC from '../../styles/common.module.css';
import SolutionService from '../../components/solution/SolutionService';
import SolutionIndustries from '../../components/solution/SolutionIndustries';
import SolutionUseCases from '../../components/solution/SolutionUseCases';


export default function SolutionPage() {
    return (
        <main className={`${stylesC.boxShadow} ${stylesC.main}`}>
            <section className={`${stylesC.boxShadow} ${stylesC.section}`}>
                <SolutionService />
            </section>
            <section className={`${stylesC.boxShadow} ${stylesC.section}`}>
                <SolutionIndustries />
            </section>
            <section className={`${stylesC.boxShadow} ${stylesC.section}`}>
                <SolutionUseCases />
            </section>
        </main>
    )
}
